import { addClass } from '@opten/dom/add-class';
import { Component } from '@opten/compiler/metadata/component';
import { debounce } from '@opten/reactive/debounce';

declare const Swiper: any;

@Component({ className: 'js-headline' })
export class HeadlineSliderComponent {
	constructor(private element: HTMLElement) {
		const slider = element.getElementsByClassName(
			'js-headline-slider'
		)[0] as HTMLElement;
		const sliderImg = element.getElementsByClassName(
			'js-headline-slider-img'
		)[0] as HTMLElement;
		const autoplay = parseInt(this.element.getAttribute('data-autoplay'), 0) || 0;

		const swiperImg = new Swiper(sliderImg, {
			speed: 1000,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
		});
		const swiper = new Swiper(slider, {
			autoplay: (autoplay > 0 ? {
				delay: 5000,
			  } : false),
			autoHeight: true,
			speed: 1000,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			thumbs: {
				swiper: swiperImg,
			},
		});
	}
}
